import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import "./src/styles/common.css";
import "./src/styles/custom-property.css";
import { GuidePageSidebarProvider } from "./src/context/guidePageSidebarContext.js";

const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY || '';

export const wrapRootElement = ({ element }) => {
	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={RECAPTCHA_KEY}
		>
			{element}
		</GoogleReCaptchaProvider>
	)
}



export const wrapPageElement = ({ element, props }) => {

	/**
	 * ガイドページ
	 */
	if (props.location.pathname.startsWith("/r-review/guide/")) {
		return (
			<GuidePageSidebarProvider>
				{element}
			</GuidePageSidebarProvider>
		);
	}

	return element;
};
